// import { Locale } from 'App/i18n' throws error we need to make a research the error
import { DomainTranslations } from 'App/i18n';
import { Locale } from 'App/i18n/enums';
import esAR from './billing.es-AR.json';
import esCL from './billing.es-CL.json';
import esCo from './billing.es-CO.json';
import esMX from './billing.es-MX.json';
import ptBR from './billing.pt-BR.json';

const billingTranslations: DomainTranslations = {
  name: 'billing',
  languages: {
    [Locale.ARGENTINA]: esAR,
    [Locale.MEXICO]: esMX,
    [Locale.BRAZIL]: ptBR,
    [Locale.CHILE]: esCL,
    [Locale.COLOMBIA]: esCo,
  },
};

export default billingTranslations;
